import type { ResponseReadAll } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import {
	type PriceStatistic,
	type PriceStatisticDTO,
	PriceStatisticTypes,
} from "epsm-api-types/models";
import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import { BaseService } from "@/services/BaseService";
import ErrorHandler from "@/services/ErrorService/ErrorService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";
import type { IReadAllParams } from "@/services/RequestParams";

export class PriceStatisticsService extends BaseService<
	PriceStatistic,
	PriceStatisticDTO
> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter(PriceStatisticTypes));
	}

	private static instance: PriceStatisticsService;

	static create() {
		if (!PriceStatisticsService.instance) {
			PriceStatisticsService.instance = new PriceStatisticsService(
				HttpClient.create(),
			);
		}
		return PriceStatisticsService.instance;
	}

	async getData(
		params: Readonly<IReadAllParams>,
		fieldMapper?: (item: PriceStatistic) => PriceInfo<UTCTimestamp>,
	): Promise<ResponseReadAll<PriceInfo<UTCTimestamp>>> {
		try {
			const response = await this.httpClient.get<
				ResponseReadAll<PriceStatisticDTO>
			>("/price-statistics", {
				params: this.getQueryParams({
					types: { date: "num" },
					...params,
				}),
			});

			return this.getResponseReadAll(response, params.types, fieldMapper);
		} catch (err) {
			ErrorHandler.logError(err);
			return {};
		}
	}
}
